import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { getUserData } from "src/api/auth";
import { useDispatch } from "react-redux";
import { types } from "src/types/types";

const Auth = ({ path, name, render }) => {
  const [isLogged, setIsLogged] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    getUserData()
      .then((data) => {
        if (!data) {
          setIsLogged(false);
          return;
        }

        setIsLogged(true);
        let userFromResponse = data.user;
        if (!userFromResponse) {
          try {
            userFromResponse = JSON.parse(
              localStorage.getItem("user") || "null"
            );
          } catch {
            userFromResponse = null;
          }
        }

        if (userFromResponse) {
          dispatch({
            type: types.login,
            payload: {
              token: localStorage.getItem("token"),
              user: userFromResponse,
            },
          });
        }
      })
      .catch(() =>
        window.location.replace(
          "/admin-printogo-static/index.html#/login"
        )
      );
  }, [dispatch]);

  return (
    <Route
      render={(props) =>
        isLogged ? (
          <Route path={path} name={name} render={render} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default Auth;
